import type {
  Action,
  ActionCrossType,
  ActionEvidence,
  ActionType,
  Nft,
  Transfer,
} from '@0xtorch/core'
import type { TransactionDetail } from '@pkg/solana'

/**
 * Action objectを生成する関数
 */
export const createAction = ({
  app,
  comment,
  crossId,
  crossType,
  evidence = 'contract',
  loanId,
  order = 0,
  source,
  target,
  transaction,
  transfers,
  type,
}: {
  app?: string
  comment?: string
  crossId?: string
  crossType?: ActionCrossType
  evidence?: ActionEvidence
  loanId?: string
  order?: number
  source: string
  target?: Nft
  transaction: TransactionDetail
  transfers: Transfer[]
  type: ActionType
}): Action => ({
  source,
  order,
  type,
  timestamp: transaction.blockTime * 1000,
  evidence,
  comment,
  app,
  transfers,
  crossId,
  crossType,
  loanId,
  target,
})
